import http from './http';
import CrudApi from './crud';

export const crud = new CrudApi('/admin/achievements');

export function updateWeights(payload) {
	return http.put('/admin/achievements/weights', payload).then(resp => resp.data);
}
